import { useState } from 'react'
import { ComissoesDashboard } from './ComissoesDashboard'
import { ComissoesStandardPanel } from './ComissoesStandardPanel'
import { ComissoesTable } from './ComissoesTable'
import { useAuthStore } from '@/stores/authStore'

function getCurrentMonth() {
  const now = new Date()
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`
}

export function ComissoesTab() {
  const { user } = useAuthStore()
  const [period, setPeriod] = useState(getCurrentMonth())

  const isAdmin = user?.role?.toLowerCase() === 'admin'

  const months = Array.from({ length: 12 }, (_, i) => {
    const now = new Date()
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1)
    const value = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`
    const label = d.toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' })
    return { value, label }
  })

  const commercialName = user?.name?.trim() || 'Comercial Rocket'

  return (
    <div className='space-y-6'>
      <ComissoesStandardPanel commercialName={commercialName} />
      {/* Filtro de período */}
      <div className='flex items-center justify-between'>
        <h3 className='font-semibold text-[var(--font-color-h3)]' style={{ fontSize: 'var(--font-size-h3)' }}>
          Comissões
        </h3>
        <select
          value={period}
          onChange={(e) => setPeriod(e.target.value)}
          className='bg-[var(--glass-bg)] border border-[var(--glass-border)] text-[var(--text-primary)] text-[13px] rounded-md px-3 py-2 outline-none focus:border-[var(--brand-primary)] transition-colors min-h-[44px] appearance-none cursor-pointer'
        >
          {months.map((m) => (
            <option key={m.value} value={m.value}>
              {m.label}
            </option>
          ))}
        </select>
      </div>

      {/* Dashboard KPIs */}
      <ComissoesDashboard period={period} />

      {/* Tabela */}
      <ComissoesTable period={period} isAdmin={isAdmin} />
    </div>
  )
}
